module.exports = __webpack_public_path__ + "img/criba2.249acf08.jpg";